// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"5e77014d","260":"3542144d","470":"1f197c55","920":"5a26a261","967":"d95ecd8e"}[chunkId] + ".css";
};